App.SupportModalComponent = Em.Component.extend
  session: Em.inject.service('session')

  fileInput: null
  selectedFiles: Em.A([])
  email: ''
  message: ''

  isSending: false


  setEmail: (->
    @set('email', @get('session.currentUser.login'))
  ).on('init')

  actions:
    sendMail: ->
      return if @get('isSending')
      @set('isSending', true)

      @get('organization').sendSupportIssue({
        email:   @get('email'),
        message: @get('message')
      }, @get('selectedFiles'))
      .catch =>
        false
      .finally =>
        # todo i18n
        alert('Спасибо! Мы свяжемся с вами в ближайшее время.')

        @set('message', '')
        @get('selectedFiles').clear()

        @send('closeModal')
        @set('isSending', false)
      false

    openFileDialog: ->
      @get('fileInput').send('openDialog')
      false

    onFileSelected: (file) ->
      @get('selectedFiles').pushObject(file)
      false

    removeFile: (file) ->
      @get('selectedFiles').removeObject(file)

    closeModal: ->
      @sendAction('onCloseModal')
